import $ from 'jquery';
import Swiper, {Navigation, Pagination} from 'swiper';

const $body = $('body');
const inBackend = $body.hasClass('neos-backend');
Swiper.use([Navigation, Pagination]);


/**
 * Swiper
 */
$('.swiper').each(function () {

    // if (inBackend) return;

    const $element = $(this);

    const slidesPerView = $element.data('slides-per-view') || 1;

    // const $slides = $element.find('.swiper-slide');
    // if ($slides.length <= slidesPerView) {
    //     return;
    // }



    new Swiper($element[0], {
        observer: true,
        observeParents: true,
        slidesPerView: 1,
        spaceBetween: 32,
        breakpoints: {
            768: {
                slidesPerView: Math.min(2, slidesPerView),
            },
            992: {
                slidesPerView: Math.min(3, slidesPerView),
            },
        },
        // autoHeight: true,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    });
});


